;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import get from "lodash/get"
import convertTimeStampOfTimezoneToLocalTime from "../../../../../lib/formatter/convertTimeStampOfTimezoneToLocalTime"
import { orderDayOfWeekArray } from "../../../../../lib/formatter/meetingTime"
import { Cohort } from "../../types"

type Props = {
  cohort: Cohort
}

type DayWindow = {
  day: string
  starts_at: string
  ends_at: string
}

export default function RecurringDaysSchedule({ cohort }: Props) {
  const items = (get(cohort, "schedule.recurring.items", []) as DayWindow[]) ?? []
  const orderDaysOfWeek = orderDayOfWeekArray(items)
  const windowsPerRecurrence = get(
    cohort,
    "schedule.recurring.windows_per_recurrence",
    1,
  ) as number
  const cohortMeetingTimezone = get(cohort, "schedule.timezone", "") as string

  function formatDays(days: string[]) {
    if (days.length === 1) return `${days[0]}s`
    if (days.length === 2) return `${days[0]}s and ${days[1]}s`

    const allButLast = days
      .slice(0, -1)
      .map((day) => `${day}s`)
      .join(", ")

    return `${allButLast}, and ${days[days.length - 1]}s`
  }

  function formatTimeString(startsAt: string, endsAt: string, recurrence: number) {
    const localStartTime = convertTimeStampOfTimezoneToLocalTime({
      time: startsAt,
      originalTimezone: cohortMeetingTimezone,
    })
    const localEndTime = convertTimeStampOfTimezoneToLocalTime({
      time: endsAt,
      originalTimezone: cohortMeetingTimezone,
    })

    return `${localStartTime} - ${localEndTime}, ${recurrence === 1 ? "weekly" : `every ${recurrence} weeks`}`
  }

  const groupedDays = orderDaysOfWeek.reduce<
    Record<string, { days: string[]; starts_at: string; ends_at: string }>
  >((acc, { day, starts_at, ends_at }) => {
    const key = `${starts_at}-${ends_at}`
    if (!acc[key]) {
      acc[key] = {
        days: [day],
        starts_at,
        ends_at,
      }
    } else {
      acc[key].days.push(day)
    }
    return acc
  }, {})

  const daysAtTimeStr = Object.values(groupedDays).map(
    ({ days, starts_at, ends_at }, index) => (
      <div className="my-[10px]" key={`days-time-str-${index}`}>
        {formatDays(days)} @{" "}
        {formatTimeString(starts_at, ends_at, windowsPerRecurrence)}
      </div>
    ),
  )

  return <div className={`text-[17px] min-[800px]:text-[18px]`}>{daysAtTimeStr}</div>
}
